import { useMutation } from "@tanstack/react-query";

import { signIn } from "../../services/auth";

import cookiesModifier from "../../utils/cookies";

const useSignIn = () => {

    const mutationFn = async (data: any) => {
        return await signIn(data.payload);
    };

    return useMutation({
        mutationFn,
        onMutate: (variables) => {
            variables.setIsProcessRunning(true);
        },
        onSuccess: (response, variables) => {
            if (response?.data) {
                const jwtPayload = JSON.parse(window.atob((response.data).split('.')[1]))
                const correntDate = new Date()
                const expirationDate = new Date(jwtPayload.exp * 1000)
                cookiesModifier.setCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string, response.data, expirationDate.getTime() - correntDate.getTime());
                variables.setServiceError(null);
                variables.callback();
            } else {
                variables.setServiceError('Oops! Something went wrong, please try again.');
            }
        },
        onError: (error: any, variables) => {
            if (error?.response?.status === 400 && error?.response?.data?.includes('User does not exist')) {
                variables.setServiceError('User does not exist!');
            } else if (error?.response?.status === 401) {
                variables.setServiceError('Wrong password!');
            } else {
                variables.setServiceError('Oops! Something went wrong, please try again.');
            }
        },
        onSettled: (data, error, variables) => {
            variables.setIsProcessRunning(false);
        }
    });
};

export default useSignIn;

